var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.url
    ? _c(
        "a",
        {
          staticClass:
            "text-sm text-primary-500 font-semibold hover:text-primary-700 truncate",
          attrs: { target: "_blank", href: _vm.url },
        },
        [_vm._v(" " + _vm._s(_vm.url) + " ")]
      )
    : _c("p", { staticClass: "text-sm font-semibold cursor-text" }, [
        _vm._v(" n/a "),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }